// src/main.js

import DEPLOYMENT from '@generio-ai/library-legacy/constants/deployment'
import NAVIGATION from '@generio-ai/library-legacy/constants/navigation'
import vuetify from '@generio-ai/library-legacy/plugins/vuetify'
import vuex, { init, register } from '@generio-ai/library-legacy/plugins/vuex'
import '@generio-ai/library-legacy/style.css'
import { version } from '../package.json'
import { createApp } from 'vue'
import Webclient from './Webclient.vue'
import router from './router/router'
import flows from '@/stores/flows'
import library from '@/stores/library'
import agent from '@/stores/agent'

// TODO move to library
import windows from '@/stores/windows'
vuex.registerModule('windows', windows)

vuex.registerModule('flows', flows)
vuex.registerModule('library', library)
vuex.registerModule('agent', agent)

register('router', router)

vuex.dispatch('deployment/setEnvironment', { environment: import.meta.env })
vuex.dispatch('deployment/setVersion', { version })
vuex.dispatch('navigation/setFocus', { focus: true })
vuex.dispatch('navigation/setExpansion', { 
	key: DEPLOYMENT.CLIENT.HOMEPAGE, 
	expansion: NAVIGATION.EXPANSION.HIDDEN
})
vuex.dispatch('navigation/setExpansion', { 
	key: DEPLOYMENT.CLIENT.APPSUITE, 
	expansion: NAVIGATION.EXPANSION.EXPANDED
})
vuex.dispatch('overlay/show')

init.then(async () => {
	/* for debugging purposes only 
	await vuex.dispatch('auth/debug', {
		token: '' 
	})
	//await vuex.dispatch('publics/debug')
	*/

	// mount app
	createApp(Webclient)
		.use(router)
		.use(vuetify)
		.use(vuex)
		.mount('#app')

	// init flows
	await vuex.dispatch('flows/init')

	// synchronize assets
	await vuex.dispatch('assets/synchronize')
})
